/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlert } from './ControlZeroDayAlert';
import {
    ControlZeroDayAlertFromJSON,
    ControlZeroDayAlertFromJSONTyped,
    ControlZeroDayAlertToJSON,
} from './ControlZeroDayAlert';
import type { ControlZeroDayAlertClientAssociation } from './ControlZeroDayAlertClientAssociation';
import {
    ControlZeroDayAlertClientAssociationFromJSON,
    ControlZeroDayAlertClientAssociationFromJSONTyped,
    ControlZeroDayAlertClientAssociationToJSON,
} from './ControlZeroDayAlertClientAssociation';

/**
 * 
 * @export
 * @interface ControlResolveZeroDayAlertResponse
 */
export interface ControlResolveZeroDayAlertResponse {
    /**
     * 
     * @type {ControlZeroDayAlert}
     * @memberof ControlResolveZeroDayAlertResponse
     */
    alert: ControlZeroDayAlert;
    /**
     * 
     * @type {ControlZeroDayAlertClientAssociation}
     * @memberof ControlResolveZeroDayAlertResponse
     */
    association: ControlZeroDayAlertClientAssociation;
}

/**
 * Check if a given object implements the ControlResolveZeroDayAlertResponse interface.
 */
export function instanceOfControlResolveZeroDayAlertResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "alert" in value;
    isInstance = isInstance && "association" in value;

    return isInstance;
}

export function ControlResolveZeroDayAlertResponseFromJSON(json: any): ControlResolveZeroDayAlertResponse {
    return ControlResolveZeroDayAlertResponseFromJSONTyped(json, false);
}

export function ControlResolveZeroDayAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolveZeroDayAlertResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alert': ControlZeroDayAlertFromJSON(json['alert']),
        'association': ControlZeroDayAlertClientAssociationFromJSON(json['association']),
    };
}

export function ControlResolveZeroDayAlertResponseToJSON(value?: ControlResolveZeroDayAlertResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alert': ControlZeroDayAlertToJSON(value.alert),
        'association': ControlZeroDayAlertClientAssociationToJSON(value.association),
    };
}

